export type LibraryKey =
  'one-drive' |
  'google-drive' |
  'zoom';

export enum LibraryName {
  OneDrive = 'OneDrive',
  GoogleDrive = 'GoogleDrive',
  Zoom = 'Zoom'
}